<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" ></ngx-loading>

    <div class="row">
        <div class="col-md-12">
            <a href="javascript:;" (click)="pdf()" class="btn btn-light-primary font-weight-bolder btn-sm mt-0 mb-5" style="float: right;"><i class=" fa fa-file-pdf"></i> PDF</a>
        </div>
    </div>
       
              <mat-tab-group class="demo-tab-group">
                <mat-tab label="Tender Information">
                  <div class="demo-tab-content">
                    <h3 class="mb-5">Tender Information </h3>
                        <div class="row">
                            <div class="col-md-12">
                                <p><b>Agency Name : </b> {{data?.agencyName}}</p>
                                <p *ngIf="data?.jabatanName"><b>Jabatan Name : </b> {{data?.jabatanName}}</p>
                                <p *ngIf="data?.ptjName"><b>PTJ Name : </b> {{data?.ptjName}}</p>
                                <p><b>Tender ID : </b> {{data?.posts?.tenderId}}</p>
                                <p><b>Title : </b> {{data?.tenderTitle}}</p>
                                <p class="description"><b>Description : </b><br/> {{data?.tenderDescription}}</p>
                            </div>
                            <div class="col-md-6">
                                <p><b>Procurement Type :</b> {{data?.posts?.procurementType}}  </p>
                                <p><b>Tender Type : </b> {{data?.tenderType == "O" ? "Open" : "Bumiputra" }}</p>
                                <p><b>Published Date : </b> {{data?.publishedDate | date:'dd-MM-yyyy h:mm a'}}</p>
                                <p><b>Opening Date : </b> {{data?.openingDate | date:'dd-MM-yyyy h:mm a'}}</p>
                                <p><b>Closing Date : </b> {{data?.closingDate | date:'dd-MM-yyyy h:mm a'}}</p>
                                <p><b>Collection Start Date : </b>  {{data?.posts?.collectionDate > data?.posts?.collectEndDate ? (data?.posts?.collectEndDate | date:'dd-MM-yyyy h:mm a'):(data?.posts?.collectionDate | date:'dd-MM-yyyy h:mm a')}}</p>
                                <p><b>Collection End Date : </b> {{data?.posts?.collectionDate > data?.posts?.collectEndDate  ? (data?.posts?.collectionDate | date:'dd-MM-yyyy h:mm a'):(data?.posts?.collectEndDate | date:'dd-MM-yyyy h:mm a')}}</p>
                                <p *ngIf="data?.posts?.collectionAddress"><b>Collection Address : </b> {{data?.posts?.collectionAddress}}</p>
                                <p *ngIf="data?.posts?.siteVisitDate"><b>Site Visit Date : </b> {{data?.posts?.siteVisitDate | date:'dd-MM-yyyy h:mm a'}} </p>
                                <p *ngIf="data?.posts?.siteVisitAddress"><b>Site Visit Address : </b> {{data?.posts?.siteVisitAddress}}</p>
                                <p *ngIf="data?.posts?.briefingDate == '' ? data?.briefingDate : data?.posts?.briefingDate"><b>Briefing Date : </b> {{data?.posts?.briefingDate == '' ? data?.briefingDate : data?.posts?.briefingDate | date:'dd-MM-yyyy h:mm a'}}</p>
                            </div>
                            <div class="col-md-6">
                                <p *ngIf="data?.posts?.briefingAddress"><b>Briefing Venue: </b> {{data?.posts?.briefingAddress}}</p>
                                <p *ngIf="data?.posts?.documentCost"><b>Document Cost : </b>  {{data?.posts?.documentCost | currency:'MYR' :'RM'}}</p>
                                <p *ngIf="data?.posts?.paymentMethod"><b>Payment Method : </b>  {{data?.posts?.paymentMethod}} </p>
                                <p *ngIf="data?.posts?.payableToName"><b>Payable To: {{data?.posts?.payableToName}} </b> </p>
                                <p *ngIf="data?.posts?.locationAddress"><b>Available at (Official Address) : </b> {{data?.posts?.locationAddress}}</p>
                                <p *ngIf="data?.tenderSource"><b>Source : </b> {{data?.tenderSource}}</p>
                                <p *ngIf="data?.posts?.sourceDescription"><b>Source Description : </b>  <a href="{{data?.posts?.sourceDescription }}" target="_blank">{{data?.posts?.sourceDescription }}</a></p>
                               
                                <div *ngIf="data?.posts?.contactPerson">
                                    <div *ngIf="data?.posts?.contactPerson.split(',').length > 1;else singleContact">
                                        <p ><b>Contact Person : </b></p>
                                        <ul>
                                            <li *ngFor="let i  of data?.posts?.contactPerson.split(',')">{{i}} </li>
                                        </ul>
                                    </div>
                                    <ng-template #singleContact>
                                        <p ><b>Contact Person : </b>{{data?.posts?.contactPerson}}</p>
                                    </ng-template>
                                </div>
    
    
                                <p *ngIf="data?.posts?.contactFax"><b>Fax No.: </b> {{data?.posts?.contactFax}}</p>
                               
                                <div *ngIf="data?.posts?.contactTelephone">
                                    <div *ngIf="data?.posts?.contactTelephone.split(',').length > 1;else singlePhone">
                                        <p ><b>Telephone No. : </b></p>
                                        <ul>
                                            <li *ngFor="let i  of data?.posts?.contactTelephone.split(',')">{{i}} </li>
                                        </ul>
                                    </div>
                                    <ng-template #singlePhone>
                                        <p ><b>Telephone No. : </b>{{data?.posts?.contactTelephone}}</p>
                                    </ng-template>
                                </div>
    
                                <div *ngIf="data?.posts?.contactEmail">
                                    <div *ngIf="data?.posts?.contactEmail.split(',').length > 1;else singleEmail">
                                        <p ><b>E-mail Address : </b></p>
                                        <ul>
                                            <li *ngFor="let i  of data?.posts?.contactEmail.split(',')">{{i}} </li>
                                        </ul>
                                    </div>
                                    <ng-template #singleEmail>
                                        <p ><b>E-mail Address : </b>{{data?.posts?.contactEmail}}</p>
                                    </ng-template>
                                </div>
    
                              
                            </div>
                        </div>
    
                  </div>
                </mat-tab>
                <mat-tab label="Location" *ngIf="data?.locations">
                  <div class="demo-tab-content">
                    
                        <div class="row mt-5">
                            <div class="col-md-12">
                                <div class="card card-custom card-stretch gutter-b">
                                    <!--begin::Header-->
                                    <div class="card-header border-0 py-5">
                                        <h3 class="card-title align-items-start flex-column">
                                            <span class="card-label font-weight-bolder text-dark">Location</span>
                                        </h3>
                                    </div>
                                    <!--end::Header-->
                                    <!--begin::Body-->
                                    <div class="card-body pt-0 pb-3">
                                        <div class="tab-content">
                                            <ul>
                                                <li *ngFor="let i of data?.locations">{{i?.name}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
                </mat-tab>
              
                <mat-tab label="MOF" *ngIf="data?.mofList?.length > 0">
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <div class="card card-custom card-stretch gutter-b">
                                <div class="card-header border-0 py-5">
                                    <h3 class="card-title align-items-start flex-column">
                                        <span class="card-label font-weight-bolder text-dark">MOF</span>
                                    </h3>
                                </div>
                                <div class="card-body pt-0 pb-3">
                                    <div class="tab-content">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr class="text-left text-uppercase">
                                                        <th  class="pl-7">
                                                            <span class="text-dark-75">No</span>
                                                        </th>
                                                        <th > <span class="text-dark-75">Category Code</span></th>
                                                        <th > <span class="text-dark-75">Category Name</span></th>
                                                        <th > <span class="text-dark-75">Sub Category</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let i of data?.mofList;let index = index">
                                                        <td >{{index +1}}</td>
                                                        <td >{{i?.code}}</td>
                                                        <td >{{i?.description}}</td>
                                                        <td >{{i?.subcategoryDescription}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="CIDB" *ngIf="data?.cidbs?.length > 0">
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <div class="card card-custom card-stretch gutter-b">
                                <div class="card-header border-0 py-5">
                                    <h3 class="card-title align-items-start flex-column">
                                        <span class="card-label font-weight-bolder text-dark">CIDB</span>
                                    </h3>
                                </div>
                                <div class="card-body pt-0 pb-3">
                                    <div class="tab-content">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr class="text-left text-uppercase">
                                                        <th  class="pl-7">
                                                            <span class="text-dark-75">No</span>
                                                        </th>
                                                        <th > <span class="text-dark-75">Category Code</span></th>
                                                        <th > <span class="text-dark-75">Category</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let i of data?.cidbs;let index = index">
                                                        <td >{{index +1}}</td>
                                                        <td >{{i?.categoryCode}}</td>
                                                        <td >{{i?.description}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
    
                <mat-tab label="CIDB Grade" *ngIf="data?.cidbGrades?.length > 0">
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <div class="card card-custom card-stretch gutter-b">
                                <div class="card-header border-0 py-5">
                                    <h3 class="card-title align-items-start flex-column">
                                        <span class="card-label font-weight-bolder text-dark">CIDB Grade</span>
                                    </h3>
                                </div>
                                <div class="card-body pt-0 pb-3">
                                    <div class="tab-content">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr class="text-left text-uppercase">
                                                        <th  class="pl-7">
                                                            <span class="text-dark-75">No</span>
                                                        </th>
                                                        <th > <span class="text-dark-75"> Code</span></th>
                                                        <th > <span class="text-dark-75">Name</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let i of data?.cidbGrades;let index = index">
                                                        <td >{{index +1}}</td>
                                                        <td >{{i?.code}}</td>
                                                        <td >{{i?.description}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
    
                <mat-tab label="Scope of Works" *ngIf="data?.scopeOfWorks?.length > 0">
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <div class="card card-custom card-stretch gutter-b">
                                <div class="card-header border-0 py-5">
                                    <h3 class="card-title align-items-start flex-column">
                                        <span class="card-label font-weight-bolder text-dark">Scope of Works </span>
                                    </h3>
                                </div>
                                <div class="card-body pt-0 pb-3">
                                    <div class="tab-content">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr class="text-left text-uppercase">
                                                        <th  class="pl-7">
                                                            <span class="text-dark-75">No</span>
                                                        </th>
                                                        <th > <span class="text-dark-75">Code</span></th>
                                                        <th > <span class="text-dark-75">Name</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let i of data?.scopeOfWorks;let index = index">
                                                        <td >{{index +1}}</td>
                                                        <td >{{i?.code}}</td>
                                                        <td >{{i?.description}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
    
                <mat-tab label="Document Attachment" *ngIf="files_upload.length > 0">
    
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <div class="card card-custom card-stretch gutter-b">
                                <div class="card-header border-0 py-5">
                                    <h3 class="card-title align-items-start flex-column">
                                        <span class="card-label font-weight-bolder text-dark">Document Attachment </span>
                                    </h3>
                                </div>
                                <div class="card-body pt-0 pb-3">
                                    <div class="tab-content">
                                        <!--begin::Table-->
                                        <div class="table-responsive">
                                            <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
                                                <thead>
                                                    <tr class="text-left text-uppercase">
                                                        <th  class="pl-7">
                                                            <span class="text-dark-75">No</span>
                                                        </th>
                                                        <th > <span class="text-dark-75">Size (KB)</span></th>
                                                        <th > <span class="text-dark-75">File</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let i of files_upload;let index= index">
                                                        <td >{{index+1}}</td>
                                                        <td >{{i?.filesize}}</td>
                                                        <td ><a href="{{i?.imageUrl}}" target="_blank">{{i?.filename}}</a></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!--end::Table-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
              </mat-tab-group>















